import request from '@/utils/request'

// 软件版本分页
export function qryDeviceData(query) {
  return request({
    url: '/admin/app/version/page',
    method: 'get',
    params: query
  })
}

// 修改软件版本
export function addDeviceData(data) {
  return request({
    url: '/admin/app/version/edit',
    method: 'post',
    data
  })
}
